import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15 22.5C15.2761 22.5 15.5 22.2761 15.5 22V10.2071L18.6464 13.3536C18.8417 13.5488 19.1583 13.5488 19.3536 13.3536C19.5488 13.1583 19.5488 12.8417 19.3536 12.6464L15.3536 8.64645C15.1583 8.45118 14.8417 8.45118 14.6464 8.64645L10.6464 12.6464C10.4512 12.8417 10.4512 13.1583 10.6464 13.3536C10.8417 13.5488 11.1583 13.5488 11.3536 13.3536L14.5 10.2071V22C14.5 22.2761 14.7239 22.5 15 22.5Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.5 1.5C4.77614 1.5 5 1.72386 5 2V13.7929L8.14645 10.6464C8.34171 10.4512 8.65829 10.4512 8.85355 10.6464C9.04882 10.8417 9.04882 11.1583 8.85355 11.3536L4.85355 15.3536C4.65829 15.5488 4.34171 15.5488 4.14645 15.3536L0.146447 11.3536C-0.0488155 11.1583 -0.0488155 10.8417 0.146447 10.6464C0.341709 10.4512 0.658292 10.4512 0.853554 10.6464L4 13.7929V2C4 1.72386 4.22386 1.5 4.5 1.5Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}